import patLogo from "../assets/PAT_logo_transparent.png";

export default function Logo({ className = "" }) {
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <img
        src={patLogo}
        alt="PAT Logo"
        className="h-full w-auto object-contain block"
      />
    </div>
  );
}
